import { createFileRoute } from '@tanstack/react-router';

import { ClientsPage } from '@/features/profiles/company-pages';

export const Route = createFileRoute('/_app/org/$orgId/clients')({ component: OrgRoute });

function OrgRoute() {
  const { orgId } = Route.useParams();
  return <ClientsPage orgId={orgId} />;
}
